import { Checkbox, FormControlLabel } from '@mui/material';
import { PricelistMailAttachmentType } from '../../common/PricePrgClient';

type Props = {
    mailAttachmentTypes: PricelistMailAttachmentType[];
    setMailAttachmentTypes(mailAttachmentTypes: PricelistMailAttachmentType[]): void;
};

export const PricelistMailAttachmentTypeChooser = ({
    mailAttachmentTypes,
    setMailAttachmentTypes
}: Props) => {
    const handleMailAttachmentTypeChanged = (
        mailAttachmentType: PricelistMailAttachmentType,
        checked: boolean
    ) => {
        if (checked) {
            if (!mailAttachmentTypes.includes(mailAttachmentType)) {
                setMailAttachmentTypes([...mailAttachmentTypes, mailAttachmentType]);
            }
        } else {
            setMailAttachmentTypes(mailAttachmentTypes.filter(type => type !== mailAttachmentType));
        }
    };

    return (
        <>
            {Object.keys(PricelistMailAttachmentType)
                .map(x => Number(x))
                .filter(x => !isNaN(x))
                .map(idx => [idx, PricelistMailAttachmentType[idx] as string] as const)
                .map(([idx, name]) => (
                    <FormControlLabel
                        key={idx}
                        control={
                            <Checkbox
                                checked={mailAttachmentTypes.includes(idx)}
                                onChange={(_, checked) => handleMailAttachmentTypeChanged(idx, checked)}
                                name={name}
                                color="primary"
                            />
                        }
                        label={name.toUpperCase()}
                    />
                ))}
        </>
    );
};
